import {EventManager} from "shared/core/Events/EventManager";
import {LoadExtensionOptions} from "FormBuilder/Events/LoadExtensionOptions";
import {ImageCondition, ImageConditionOptions} from "./ImageConditionOptions";
import {ShowHideConditionProcessor} from "FormBuilder/Core/Conditions/ShowHideConditionProcessor";
import {ShowHideConditionOptions} from "FormBuilder/Fields/Core/ConditionOptions";
import {ImageConditionProcessor} from "./ImageConditionProcessor";

EventManager.Subscribe(LoadExtensionOptions,(event)=>{
    let currentOptions:ImageConditionOptions=event.Model.Options.Extensions.find(x=>x.Id=='ImageCondition') as ImageConditionOptions;
    if(currentOptions==null)
        event.Model.Options.Extensions.push(new ImageConditionOptions().Merge());
    else
        event.Model.Options.Extensions[event.Model.Options.Extensions.indexOf(currentOptions)]=new ImageConditionOptions().Merge(currentOptions);

    currentOptions=event.Model.Options.Extensions.find(x=>x.Id=='ImageCondition') as ImageConditionOptions;

    if(!event.Model.IsDesign())
    {
        for(let condition of currentOptions.ClientOptions.Conditions)
            new ImageConditionProcessor().Initialize(event.Model,condition)
    }


});

